import { apiRequest } from './client';

export interface CityProgress {
  city_id: string;
  city_name: string;
  country_code: string;
  visited_cells_count: number;
  total_cells: number;
  first_visited_at: string;
  last_visited_at: string;
  percentage: number;
}

export async function fetchAllProgress(): Promise<CityProgress[]> {
  const data = await apiRequest<{ progress: CityProgress[] }>('/progress');
  return data.progress;
}
